import { render, staticRenderFns } from "./SelectSpectrum.vue?vue&type=template&id=253df304"
import script from "./SelectSpectrum.vue?vue&type=script&lang=js"
export * from "./SelectSpectrum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports